import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';

import { checkAuth } from 'cityads-v3/actions/auth';

import Dialog from 'cityads-v3/components/Dialog/Dialog'
import HomeWidgetLoading from 'cityads-v3/components/Home/Widgets/Loading';

import LoginIframe from './LoginIframe';

import classNames from "./LoginDialog.scss";

@connect(
  state => ({
    isCheckingAuth  : state.auth.checkingAuth,
    isSettingUid    : state.auth.referralUidSetting,
    isSettingClickId: state.auth.clickIdSetting,
    cookie          : state.auth.cookie,
    isMobile        : state.app.isMobile,
  })
)
@withTranslation(['main'], { i18n, wait: false })
export default class LoginDialog extends Component {

  static propTypes = {
    dispatch        : PropTypes.func.isRequired,
    onRequestClose  : PropTypes.func,
    isCheckingAuth  : PropTypes.bool,
    isSettingUid    : PropTypes.bool,
    isSettingClickId: PropTypes.bool,
    cookie          : PropTypes.string,
    isMobile        : PropTypes.bool,
  }

  componentDidMount() {
    const { dispatch, isCheckingAuth, cookie } = this.props;

    if (!isCheckingAuth) {
      dispatch(checkAuth({ cookies: cookie }))
        .catch(() => console.warn('Not logged in'))
      ;
    }
  }

  getLoginDialogTabs() {
    const { t, isSettingUid, isSettingClickId, isCheckingAuth } = this.props;
    const tabs = [
      {
        value   : 'login',
        label   : t('enter'),
        children: (isSettingUid || isSettingClickId || isCheckingAuth) ?
          <HomeWidgetLoading /> :
          <LoginIframe className={classNames.loginFrame} />
      },
    ];

    return tabs;
  }

  render() {
    return (
      <Dialog
        open           = {true}
        onRequestClose = {this.props.onRequestClose}
        closeLink      = {this.props.closeLink}
        tab            = "login"
        tabs           = {this.getLoginDialogTabs()}
        fullScreen     = {this.props.isMobile}
      />
    );
  }

}
